import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { DetailPageTopBarHeading } from "../../../../components/atoms";
import { UserAvatar } from "../../../../components/atoms/Avatar";
import { DetailPageGoToPreviousPageIcon } from "../../../../components/atoms/Icons";
import { useTaskProgressMountRef } from "../../../../components/organisms/Provider";
import { DetailPageTopBarLeft } from "../../../../components/organisms/TopBar/Detail";
import { useLogoutMutation } from "../../../../store/apiSlice/authApiSlice";
import { CaretDown } from "../../assets/svgIcon/topBar/CaretDown";
import { GlobalCreateButton } from "./components/GlobalCreateButton";
import { NotificationBell } from "./components/NotificationBell";
import { PopupModal } from "./PopupModal/PopupModal";
import "./TopBar.css";

export function TopBar({ title, isMasterModule = false, backUrl, actions }) {
  const [isOpenProfile, setisOpenProfile] = useState(false);
  const taskProgressMountRef = useTaskProgressMountRef();

  const { user } = useSelector(state => state.auth);

  const [logout] = useLogoutMutation();

  const doLogout = async () => {
    await logout();
  };

  const openProfile = () => {
    setisOpenProfile(true);
  };
  const closeProfile = () => {
    setisOpenProfile(false);
  };

  const previousUrl = backUrl || (isMasterModule ? "/master" : null);

  return (
    <div className="topBar">
      <DetailPageTopBarLeft>
        {previousUrl && <DetailPageGoToPreviousPageIcon navigateURL={previousUrl} />}
        <DetailPageTopBarHeading>{title}</DetailPageTopBarHeading>
      </DetailPageTopBarLeft>

      <div className="rightBar">
        {actions}
        <GlobalCreateButton />
        <NotificationBell />
        <div ref={taskProgressMountRef} className="taskProgressMount item" data-menu="Tasks" />
        <div onClick={openProfile} className={isOpenProfile ? "activeProfile profile" : "profile"}>
          {user?.profile_photo || user?.avatar_key ? (
            <UserAvatar user={user} size={40} />
          ) : (
            <span className="nameIcon">
              {user?.is_superuser ? "SU" : user?.company && user?.company[0]}{" "}
            </span>
          )}
          {user?.is_superuser ? user?.first_name : user?.company}
          <CaretDown color={isOpenProfile ? "#1249BF" : "black"} />
          {isOpenProfile && user && (
            <PopupModal styleOfModal={styleOfModal} closeModal={closeProfile}>
              <UserAccounInfo user={user} doLogout={doLogout} />
            </PopupModal>
          )}
        </div>
      </div>
    </div>
  );
}

const styleOfModal = {
  position: "absolute",
  top: "50px",
  right: 0,
  zIndex: 11,
};

const UserAccounInfo = ({ user, doLogout }) => {
  return (
    <UserAccounInfoCss>
      <div className="groupInfo">{user.is_superuser ? "Super User" : user.groups[0]?.name}</div>
      <div className="userInfo">
        <UserAvatar user={user} size={40} />
        <div className="accInfo">
          <div className="nameOfUser">{user?.full_name} </div>
          <div className="userEmail">{user?.email} </div>
        </div>
      </div>
      <div className="sepratorLine"></div>

      <div className="otherNavLinks">
        <Link className="linkItem" to={"/account"}>
          My Account{" "}
        </Link>
        <Link className="linkItem" to={"/organization"}>
          Organization Details
        </Link>
        <Link className="linkItem" to={"/users"}>
          Users{" "}
        </Link>
        <div className="linkItem" onClick={doLogout}>
          Sign out{" "}
        </div>
      </div>
    </UserAccounInfoCss>
  );
};

const UserAccounInfoCss = styled.div`
  padding: 16px;
  padding-bottom: 12px;
  position: relative;
  font-family: Inter;
  border-radius: 4px;
  border: 1px solid var(--SILVER, #dadff3);
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 272px;
  cursor: default;

  > .groupInfo {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 1px 8px;
    border-radius: 4px;
    background-color: #cce5ff;
    color: var(--Dark-Grey, #262641);
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.3px;
  }
  > .userInfo {
    display: flex;
    align-items: center;
    gap: 12px;
    > .accInfo {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 2px;

      > .userEmail {
        font-size: 12px;
      }
    }
  }

  > .sepratorLine {
    margin-top: 16px;
    margin-bottom: 12px;
    border-bottom: 1px solid #e9edf5;
  }

  > .otherNavLinks {
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    > .linkItem {
      cursor: pointer;
      color: #000;

      &:hover {
        color: var(--Primary-Blue, #2060ea);
      }
    }
  }
`;
